import { render, staticRenderFns } from "./QuickAccess.vue?vue&type=template&id=0ecb5d5e&scoped=true"
import script from "./QuickAccess.vue?vue&type=script&lang=js"
export * from "./QuickAccess.vue?vue&type=script&lang=js"
import style0 from "./QuickAccess.vue?vue&type=style&index=0&id=0ecb5d5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecb5d5e",
  null
  
)

export default component.exports